module.exports = __webpack_public_path__ + "static/geotief-logo-e9483abc7a90db02f51966565cfdaf5b.png";